<template>
  <div>
    <header class="top-0 fixed w-full left-0 right-0">
      <!-- Announcement -->
      <div
        v-if="showAnnouncement"
        class="bg-primary px-4 py-2.5 w-full flex max-w-[480px] mx-auto items-center justify-between cursor-pointer"
        @click="handleAnnouncementClick"
      >
        <div class="flex items-center gap-2">
          <img
            :src="AnnouncementIcon"
            alt="Announcement Icon"
            class="w-4 h-4"
          />
          <p class="text-xs font-bold text-white">
            {{
              systemStatusStore.announcementData?.title ||
              'Layanan akan melakukan pemeliharaan sistem'
            }}
          </p>
        </div>
        <img :src="IconRightWhite" alt="Right Arrow Icon" class="w-1.5 h-2.5" />
      </div>

      <div class="top-bar-white">
        <template v-if="props.title">
          <div
            class="flex items-center gap-4"
            :class="{
              'w-full justify-center':
                props.hideBackButton || props.centerTitle,
              'justify-center': props.centerTitle && !props.hideBackButton
            }"
          >
            <el-icon
              v-if="!props.hideBackButton"
              class="w-[24px] h-[24px] cursor-pointer"
              @click="handleButtonClick"
            >
              <Close v-if="props.showCloseButton" />
              <ArrowLeftBold v-else />
            </el-icon>
            <div
              class="mid-text-h6 font-bold"
              :class="{ 'cursor-pointer': props.clickableTitle }"
              @click="props.clickableTitle && handleButtonClick()"
            >
              {{ props.title }}
            </div>
          </div>
        </template>
        <template v-else>
          <img
            class="cursor-pointer w-[153px] h-[40px]"
            src="./assets/logo-small.png"
            @click="router.push({ name: 'home' })"
            alt="home"
          />
          <img
            class="cursor-pointer w-[24px] h-[24px]"
            src="./assets/profile.png"
            @click="router.push({ name: 'profile' })"
            alt="profile"
          />
        </template>
      </div>
    </header>
    <AnnouncementDialog
      v-model="showAnnouncementDialog"
      :title="systemStatusStore.announcementData?.title || ''"
      :description="systemStatusStore.announcementData?.description || ''"
    />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useSystemStatusStore } from '@/stores/system-status-store'
import AnnouncementIcon from './assets/announcement-icon.png'
import IconRightWhite from './assets/icon-right-white.png'
import AnnouncementDialog from './AnnouncementDialog.vue'

import { ArrowLeftBold, Close } from '@element-plus/icons-vue'
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  hideBackButton: {
    type: Boolean,
    default: false
  },
  showCloseButton: {
    type: Boolean,
    default: false
  },
  closeAction: {
    type: Function,
    default: null
  },
  backAction: {
    type: Function,
    default: null
  },
  centerTitle: {
    type: Boolean,
    default: false
  },
  // Opt-in: makes the title text trigger the same action as the back button,
  // giving a much larger tap target than the 24px icon alone.
  clickableTitle: {
    type: Boolean,
    default: false
  }
})

const router = useRouter()
const route = useRoute()
const systemStatusStore = useSystemStatusStore()

const showAnnouncementDialog = ref(false)

const showAnnouncement = computed(() => {
  return systemStatusStore.isAnnouncementVisible && route.path === '/home'
})

onMounted(() => {
  systemStatusStore.getSystemStatus()
})

const handleAnnouncementClick = () => {
  showAnnouncementDialog.value = true
}

const handleButtonClick = () => {
  if (props.showCloseButton && props.closeAction) {
    props.closeAction()
  } else if (props.backAction) {
    props.backAction()
  } else {
    router.go(-1)
  }
}
</script>

<style lang="scss">
header.fixed {
  z-index: 50;
}

.top-bar,
.top-bar-white {
  position: relative;
  left: 0;
  right: 0;
  padding-top: 0.75rem; /* py-3 */
  padding-bottom: 0.75rem;
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  height: 53px;
  background-color: #fff;
  color: var(--color-black-500);
  box-shadow: 0 1px 4px 0 rgba(117, 117, 117, 0.25);
}

.top-bar .el-icon,
.top-bar-white .el-icon {
  color: #1b1d21 !important;
}

.top-bar .mid-text-h6,
.top-bar-white .mid-text-h6 {
  color: #1b1d21 !important;
}
</style>
